/* Texto SEO: coloca cada imagen, video o ficha "después del bloque N" del texto, sin tocar el texto,
   deja los fondos detrás del texto y anima las barras de la ficha al entrar en pantalla. */
(function () {
  function place(root) {
    if (root.getAttribute('data-placed')) return;
    root.setAttribute('data-placed', '1');
    var body = root.querySelector('.kb-pseo__body');
    var figs = root.querySelectorAll('[data-kb-pseo-fig][data-after]');
    if (!body || !figs.length) return;
    var blocks = Array.prototype.slice.call(body.children);
    var tail = {};
    var head = null;
    var fondos = [];
    Array.prototype.forEach.call(figs, function (fig) {
      var n = parseInt(fig.getAttribute('data-after'), 10);
      if (isNaN(n) || !blocks.length) return;
      if (fig.hasAttribute('data-fondo')) { fig._n = n; fondos.push(fig); return; }
      if (n <= 0) {
        if (head) head.after(fig); else body.insertBefore(fig, body.firstChild);
        head = fig;
        return;
      }
      var i = Math.min(n, blocks.length) - 1;
      var prev = tail[i] || blocks[i];
      prev.after(fig);
      tail[i] = fig;
    });
    if (fondos.length) {
      var put = function () {
        fondos.forEach(function (fig) {
          var n = fig._n;
          var a = n > 0 ? blocks[Math.min(n, blocks.length) - 1] : null;
          fig.style.top = (a ? a.offsetTop + a.offsetHeight : 0) + 'px';
        });
      };
      fondos.forEach(function (fig) { body.appendChild(fig); });
      put();
      if ('ResizeObserver' in window) new ResizeObserver(put).observe(body); else window.addEventListener('resize', put);
    }
  }

  function bars(root) {
    var f = root.querySelector('[data-kb-ficha]');
    if (!f || f.getAttribute('data-armed')) return;
    f.setAttribute('data-armed', '1');
    if (!('IntersectionObserver' in window)) return;
    f.classList.add('is-armed');
    new IntersectionObserver(function (es, ob) {
      if (es[0].isIntersecting) { f.classList.add('is-in'); ob.disconnect(); }
    }, { threshold: 0.25 }).observe(f);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kb-pseo]'), function (r) { place(r); bars(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
